export const movies = [
  {
    id: 'movie-1',
    kind: 'movie' as const,
    title: '星际远航',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20deep%20space%20spaceship%20above%20blue%20planet%2C%20dramatic%20lighting%2C%20dark%20navy%20tones%2C%20no%20text%2C%20highly%20detailed%20illustration&width=400&height=600&seq=movie-poster-01&orientation=portrait',
    genres: ['科幻', '动作'],
    region: '国产',
    year: 2025,
    duration: '142分钟',
    director: '陈牧云',
    cast: ['林昭', '苏晚', '周砚'],
    rating: 8.7,
    popularity: 98,
    synopsis:
      '一支肩负人类希望的深空探索舰队，穿越虫洞前往未知星系寻找可宜居的星球。当飞船偏离预定航线、通讯彻底中断后，船员们必须在资源耗尽前做出抉择：返航求生，还是继续向前揭开宇宙深处的秘密。影片以恢弘的视效与克制的叙事，探讨了孤独、信任与人类文明的韧性。'
  },
  {
    id: 'movie-2',
    kind: 'movie' as const,
    title: '都市迷情',
    poster: 'https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20with%20city%20skyline%20at%20dusk%2C%20warm%20orange%20and%20deep%20blue%20gradient%20sky%2C%20silhouette%20of%20a%20couple%2C%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=movie-poster-02&orientation=portrait',
    genres: ['爱情', '剧情'],
    region: '国产',
    year: 2024,
    duration: '118分钟',
    director: '许清和',
    cast: ['顾言', '温澜', '梁川'],
    rating: 7.9,
    popularity: 86,
    synopsis:
      '两个在大城市打拼的年轻人因一场误会相识，从针锋相对到彼此依靠。快节奏的都市生活里，他们一边追逐各自的事业理想，一边学着如何在一段关系里坦诚与被理解。这是一部关于成长、选择与勇气的都市爱情故事。'
  },
  {
    id: 'movie-3',
    kind: 'movie' as const,
    title: '暗夜追凶',
    poster: 'https://readdy.ai/api/search-image?query=dark%20crime%20thriller%20movie%20poster%2C%20rainy%20night%20city%20street%2C%20lone%20detective%20silhouette%20under%20street%20lamp%2C%20moody%20blue%20tones%2C%20suspenseful%20atmosphere%2C%20no%20text&width=400&height=600&seq=movie-poster-03&orientation=portrait',
    genres: ['悬疑', '犯罪'],
    region: '欧美',
    year: 2025,
    duration: '126分钟',
    director: 'Marcus Reed',
    cast: ['Ethan Cole', 'Nora Bennett', 'Liam Ash'],
    rating: 8.4,
    popularity: 93,
    synopsis:
      '一桩沉寂多年的悬案随着一名退休警探的回归重新浮出水面。随着调查深入，他发现线索竟指向自己最信任的同僚。真相与谎言交织，正义的边界变得模糊。影片以冷峻的影像风格和缜密的推理节奏，构建出一场令人屏息的心理博弈。'
  },
  {
    id: 'movie-4',
    kind: 'movie' as const,
    title: '爆笑一家人',
    poster: 'https://readdy.ai/api/search-image?query=cheerful%20family%20comedy%20movie%20poster%2C%20bright%20colorful%20living%20room%2C%20warm%20sunlight%2C%20playful%20happy%20atmosphere%2C%20orange%20and%20cream%20tones%2C%20no%20text&width=400&height=600&seq=movie-poster-04&orientation=portrait',
    genres: ['喜剧', '家庭'],
    region: '国产',
    year: 2023,
    duration: '105分钟',
    director: '钱多多',
    cast: ['葛大壮', '柳芳', '张小满'],
    rating: 7.2,
    popularity: 74,
    synopsis:
      '一个三代同堂的普通家庭，因为一次意外的旅行计划而闹出一连串啼笑皆非的故事。爷爷固执、爸爸马虎、孩子机灵，一家人在鸡飞狗跳中学会了理解与包容。笑点密集又不失温情，适合全家人一起观看。'
  },
  {
    id: 'movie-5',
    kind: 'movie' as const,
    title: '山海秘境',
    poster: 'https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%2C%20misty%20ancient%20mountains%20and%20magical%20forest%2C%20golden%20glow%2C%20epic%20mystical%20atmosphere%2C%20teal%20and%20gold%20tones%2C%20no%20text&width=400&height=600&seq=movie-poster-05&orientation=portrait',
    genres: ['奇幻', '冒险'],
    region: '国产',
    year: 2024,
    duration: '134分钟',
    director: '白子墨',
    cast: ['云澜', '谢无咎', '阿宁'],
    rating: 8.1,
    popularity: 89,
    synopsis:
      '传说中的山海秘境藏着能改写命运的力量。少年为寻找失踪的师父，踏上穿越上古山脉的旅程，途中结识了来历神秘的旅伴。古老神兽、失落文明与宿命的真相逐一展开，一场关于守护与传承的东方奇幻冒险就此启程。'
  },
  {
    id: 'movie-6',
    kind: 'movie' as const,
    title: '末日边境',
    poster: 'https://readdy.ai/api/search-image?query=post-apocalyptic%20sci-fi%20thriller%20movie%20poster%2C%20desolate%20ruined%20landscape%2C%20dusty%20amber%20sky%2C%20lone%20survivor%20figure%2C%20gritty%20dramatic%20mood%2C%20no%20text&width=400&height=600&seq=movie-poster-06&orientation=portrait',
    genres: ['科幻', '惊悚'],
    region: '欧美',
    year: 2025,
    duration: '121分钟',
    director: 'Olivia Grant',
    cast: ['Ryan Hale', 'Mia Torres', 'Caleb Stone'],
    rating: 8.0,
    popularity: 88,
    synopsis:
      '在一场席卷全球的灾难之后，幸存者们在资源匮乏的废土上艰难求生。一名前工程师发现了一处可能存在补给的神秘信号源，于是带领小队穿越危险的边境地带。信任与背叛、希望与绝望在旅途中不断拉扯。'
  },
  {
    id: 'movie-7',
    kind: 'movie' as const,
    title: '樱花之约',
    poster: 'https://readdy.ai/api/search-image?query=gentle%20japanese%20romance%20drama%20movie%20poster%2C%20cherry%20blossom%20trees%20along%20a%20quiet%20lane%2C%20soft%20pink%20petals%2C%20warm%20spring%20light%2C%20hopeful%20atmosphere%2C%20no%20text&width=400&height=600&seq=movie-poster-07&orientation=portrait',
    genres: ['爱情', '剧情'],
    region: '日韩',
    year: 2024,
    duration: '112分钟',
    director: '山田遥',
    cast: ['佐藤凛', '高桥葵', '森井悠'],
    rating: 7.8,
    popularity: 79,
    synopsis:
      '每年樱花盛开的时节，小镇上都会举办一场约定俗成的相聚。一对分隔两地的旧友在多年之后重逢，彼此的生活早已不同。在花期短暂的几周里，他们重新面对那些未曾说出口的心意。一个关于时间、遗憾与重逢的温柔故事。'
  },
  {
    id: 'movie-8',
    kind: 'movie' as const,
    title: '江湖再起',
    poster: 'https://readdy.ai/api/search-image?query=chinese%20wuxia%20martial%20arts%20movie%20poster%2C%20lone%20swordsman%20standing%20on%20misty%20cliff%2C%20flowing%20robes%2C%20dramatic%20ink%20wash%20style%2C%20deep%20blue%20and%20silver%20tones%2C%20no%20text&width=400&height=600&seq=movie-poster-08&orientation=portrait',
    genres: ['武侠', '动作'],
    region: '国产',
    year: 2023,
    duration: '128分钟',
    director: '独孤影',
    cast: ['萧无声', '叶轻眉', '铁风'],
    rating: 8.2,
    popularity: 85,
    synopsis:
      '沉寂十年的剑客重出江湖，只为查明当年师门覆灭的真相。刀光剑影之间，恩怨情仇逐一揭开。江湖从来不缺传说，缺的是愿意为义字赴险的人。影片以凌厉的武打设计和诗意的画面，再现了一个快意恩仇的武侠世界。'
  },
  {
    id: 'movie-9',
    kind: 'movie' as const,
    title: '天空之城日记',
    poster: 'https://readdy.ai/api/search-image?query=whimsical%20animated%20family%20movie%20poster%2C%20floating%20island%20city%20in%20soft%20clouds%2C%20bright%20pastel%20sky%2C%20magical%20dreamy%20atmosphere%2C%20no%20text&width=400&height=600&seq=movie-poster-09&orientation=portrait',
    genres: ['动画', '家庭'],
    region: '日韩',
    year: 2025,
    duration: '98分钟',
    director: '新海翔',
    cast: ['配音：樱井空', '配音：铃木凉'],
    rating: 8.6,
    popularity: 91,
    synopsis:
      '一座漂浮在云层之上的城市里，住着一位喜欢记录生活的少女。某天，一封来自地面的信改变了她的日常。为了寻找信中提到的那片风景，她踏上了一段穿越云海的旅程。画风清新治愈，讲述关于梦想与牵挂的故事。'
  },
  {
    id: 'movie-10',
    kind: 'movie' as const,
    title: '沉默证词',
    poster: 'https://readdy.ai/api/search-image?query=legal%20mystery%20drama%20movie%20poster%2C%20dim%20courtroom%20interior%20with%20a%20single%20window%20light%20beam%2C%20tense%20serious%20mood%2C%20muted%20steel%20blue%20tones%2C%20no%20text&width=400&height=600&seq=movie-poster-10&orientation=portrait',
    genres: ['悬疑', '剧情'],
    region: '欧美',
    year: 2024,
    duration: '130分钟',
    director: 'Sophia Lane',
    cast: ['Daniel Frost', 'Grace Kim', 'Henry Boyd'],
    rating: 8.3,
    popularity: 82,
    synopsis:
      '一场看似证据确凿的审判，因一份突然出现的沉默证词而彻底转向。年轻律师坚持追查真相，却在层层阻碍中触及了不该触碰的利益。影片在法庭的唇枪舌剑与人性的幽微之间来回切换，呈现出对正义的深刻追问。'
  },
  {
    id: 'movie-11',
    kind: 'movie' as const,
    title: '热血青春',
    poster: 'https://readdy.ai/api/search-image?query=youth%20sports%20movie%20poster%2C%20energetic%20teenagers%20on%20a%20running%20track%20at%20sunrise%2C%20vibrant%20orange%20glow%2C%20inspiring%20dynamic%20atmosphere%2C%20no%20text&width=400&height=600&seq=movie-poster-11&orientation=portrait',
    genres: ['青春', '运动'],
    region: '国产',
    year: 2023,
    duration: '115分钟',
    director: '夏一鸣',
    cast: ['陆晨曦', '韩梓宣', '程野'],
    rating: 7.5,
    popularity: 72,
    synopsis:
      '一支濒临解散的高中转学队，在新教练的带领下重新出发。从互相看不顺眼到并肩作战，少年们用汗水和不甘写下了属于自己的青春注脚。这是一个关于热爱、坚持与团队的故事，献给每一个为梦想努力过的人。'
  },
  {
    id: 'movie-12',
    kind: 'movie' as const,
    title: '环球寻宝记',
    poster: 'https://readdy.ai/api/search-image?query=lighthearted%20adventure%20comedy%20movie%20poster%2C%20world%20map%20and%20ancient%20compass%2C%20colorful%20travel%20motifs%2C%20warm%20golden%20and%20teal%20tones%2C%20no%20text&width=400&height=600&seq=movie-poster-12&orientation=portrait',
    genres: ['冒险', '喜剧'],
    region: '欧美',
    year: 2025,
    duration: '119分钟',
    director: 'Jack Wilson',
    cast: ['Tom Rivera', 'Anna Lopez', 'Ben Carter'],
    rating: 7.6,
    popularity: 77,
    synopsis:
      '一位不太靠谱的历史学家和一位务实能干的考古技师临时组队，围绕一份古老地图展开环球寻宝。一路上他们误打误撞、笑料百出，却也在冒险中发现了比宝藏更珍贵的东西。轻松有趣的合家欢冒险喜剧。'
  }
];